import { z } from "zod";
import { resolveEventBrandingStoragePath } from "./storage-file.schemas.js";

export const WritableEventBrandingUrlSchema = z.url({ protocol: /^https?$/ });

const ManagedEventBrandingUrlSchema = z
  .string()
  .refine(
    (value) => resolveEventBrandingStoragePath(value) !== null,
    "Invalid managed event branding URL",
  );

export const EventBrandingUrlSchema = z.union([
  WritableEventBrandingUrlSchema,
  ManagedEventBrandingUrlSchema,
]);

export type EventBrandingUrl = z.infer<typeof EventBrandingUrlSchema>;
